<template>
  <v-sheet class="mt-4 px-3 py-4">
    <p>- Note:</p>
    <ul>
      <li
        v-for="metric of Object.entries(metrics)"
        :key="metric[0]"
      >
        <p>{{ metric[0] }}: {{ metric[1] }}</p>
      </li>
    </ul>
  </v-sheet>
</template>

<script>
export default {
  name: 'MetricDefinitionList',
  props: ['metrics'],
};
</script>

<style scoped>
p {
  margin: 0;
}
</style>
